import { c as _c } from "react/compiler-runtime";
import { cn } from "@/lib/utils";

// Стопка миниатюр товаров «внахлёст» для строки таблицы: сразу видно, что
// внутри заказа/корзины, без открытия детали. Показываем не больше `max`
// фото, остаток сворачиваем в бейдж «+N». Используется в заказах и корзинах,
// поэтому вынесено в общий компонент.
export type ThumbItem = {
  photo?: string;
  name?: string;
};
export function StackedThumbs(t0) {
  const $ = _c(15);
  const {
    items,
    max: t1,
    className
  } = t0;
  const max = t1 === undefined ? 3 : t1;
  if (items.length === 0) {
    let t2;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
      t2 = <span className="text-muted-foreground">—</span>;
      $[0] = t2;
    } else {
      t2 = $[0];
    }
    return t2;
  }
  let rest;
  let t2;
  let t3;
  if ($[1] !== className || $[2] !== items || $[3] !== max) {
    const shown = items.slice(0, max);
    rest = items.length - shown.length;
    if ($[7] !== className) {
      t2 = cn("flex items-center", className);
      $[7] = className;
      $[8] = t2;
    } else {
      t2 = $[8];
    }
    t3 = shown.map(_temp);
    $[1] = className;
    $[2] = items;
    $[3] = max;
    $[4] = rest;
    $[5] = t2;
    $[6] = t3;
  } else {
    rest = $[4];
    t2 = $[5];
    t3 = $[6];
  }
  let t4;
  if ($[9] !== rest) {
    t4 = rest > 0 && <div className="-ml-2 flex size-8 shrink-0 items-center justify-center rounded-full bg-muted text-xs font-medium text-muted-foreground ring-2 ring-background">+{rest}</div>;
    $[9] = rest;
    $[10] = t4;
  } else {
    t4 = $[10];
  }
  let t5;
  if ($[11] !== t2 || $[12] !== t3 || $[13] !== t4) {
    t5 = <div className={t2}>{t3}{t4}</div>;
    $[11] = t2;
    $[12] = t3;
    $[13] = t4;
    $[14] = t5;
  } else {
    t5 = $[14];
  }
  return t5;
}
function _temp(it, i) {
  return <div key={i} title={it.name} className={cn("size-8 shrink-0 overflow-hidden rounded-full bg-muted ring-2 ring-background", i > 0 && "-ml-2")}>{it.photo ? <img src={it.photo} alt="" className="size-full object-cover" /> : null}</div>;
}